import { useEffect } from 'react'

import { useIsEmbedded } from './useIsEmbedded'

export function EmbedRoot() {
  const isEmbedded = useIsEmbedded()
  useEffect(() => {
    if (!isEmbedded) return
    void import('iframe-resizer/js/iframeResizer.contentWindow.js')
    // Tag <html> so global CSS can drop full-viewport heights and large
    // page-level paddings that fight iframe-resizer when the page is embedded.
    document.documentElement.setAttribute('data-cai-embed', '1')
    return () => {
      document.documentElement.removeAttribute('data-cai-embed')
    }
  }, [isEmbedded])
  return null
}
